import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, PlusCircle, Settings, LogOut, Package, Menu, X } from 'lucide-react';
import '../admin.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    if (window.confirm('Выйти из админки?')) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
  };

  return (
    <div className='admin-container'>
      <button className='mobile-menu-btn' onClick={() => setSidebarOpen(!sidebarOpen)}>
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className='sidebar-header'>
          <h2>YOONIX.SHOP <span className='highlight'>ADMIN</span></h2>
        </div>
        <nav className='sidebar-nav'>
          <NavLink to='/admin' end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={()=>setSidebarOpen(false)}>
            <LayoutDashboard size={20} /> Обзор
          </NavLink>
          <NavLink to='/admin/products' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={()=>setSidebarOpen(false)}>
            <Package size={20} /> Товары
          </NavLink>
          <NavLink to='/admin/add' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={()=>setSidebarOpen(false)}>
            <PlusCircle size={20} /> Добавить
          </NavLink>
          <NavLink to='/admin/settings' className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={()=>setSidebarOpen(false)}>
            <Settings size={20} /> Настройки
          </NavLink>
        </nav>
        <div className='sidebar-footer'>
          <button onClick={handleLogout} className='btn-logout-sidebar'>
            <LogOut size={18} /> Выход
          </button>
        </div>
      </aside>
      <main className='content-area'>
        <Outlet />
      </main>
      
      {/* Overlay for mobile when sidebar is open */}
      {sidebarOpen && (
          <div 
            style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0,0,0,0.5)', zIndex: 90}} 
            onClick={()=>setSidebarOpen(false)}
          />
      )}
    </div>
  );
};

export default AdminLayout;
